import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import { legacyAmountFilter, deadlineMonthsFilter } from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { PublicOfferAsset } from '.';

export const publicOfferTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Tipo Oferta', orderValue: 'offerType' },
  { title: 'Empresa', orderValue: 'companyName', flex: 2 },
  { title: 'Nome', orderValue: 'offerName', flex: 2 },
  { title: 'Cód. Isin', orderValue: 'isinCode' },
  { title: 'Alteração', orderValue: 'alterationDateNormalized' },
  { title: 'Negociação', orderValue: 'negotiationDateNormalized' },
  { title: 'Liquidação', orderValue: 'liquidityDateNormalized' },
  { title: 'Limitador', orderValue: 'limiter', flex: 1.5 },
  { title: '' },
];

export const publicOfferConstants = {
  id: 'publicOffers',
  typeGetterId: 'publicOffers',
  title: 'Ofertas Públicas',
  operationId: 1,
  operationName: 'Compra',
  operationType: 'buy' as OperationType,
  color: 'product.ofertapublica' as ColorTypes.Option,
  principalComponent: PublicOfferAsset,
  tableHead: publicOfferTableHead,
  hideTableHead: false,
  marketStatusSelector: emptyMarketStatusQuery,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [...transformCustomFilters(customFilters), legacyAmountFilter, deadlineMonthsFilter];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'offerTypeId',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'offerTypeId'),
  captions: [] as AssetCaptionType[],
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: '',
  unleashFlagBatchTicket: '',
  unleashFlagCustomers: Constant.UnleashCustomersPublicOffersToggle,
} as const;
